import Icon from './Icon.jsx'

/*
 * Tab bar — DESIGN.md: active tab marked by a violet underline + icon.
 * Controlled: parent owns the active key (often mirrored to ?tab=).
 */
export default function Tabs({ tabs, active, onChange }) {
  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4, rowGap: 0, borderBottom: '1px solid var(--color-border)', marginBottom: 22 }}>
      {tabs.map((tb) => {
        const on = tb.key === active
        return (
          <button
            key={tb.key}
            onClick={() => onChange(tb.key)}
            style={{
              display: 'inline-flex', alignItems: 'center', gap: 8, padding: '12px 16px',
              background: 'none', border: 'none', borderBottom: '2px solid ' + (on ? 'var(--color-primary)' : 'transparent'),
              color: on ? 'var(--color-primary)' : 'var(--color-text)', fontWeight: 600, fontSize: 14,
              marginBottom: -1, whiteSpace: 'nowrap', cursor: 'pointer',
            }}
          >
            {tb.icon && <Icon name={tb.icon} size={17} />}
            {tb.label}
          </button>
        )
      })}
    </div>
  )
}
